import { sha256Fingerprint } from '@testfeed/core';
/** Portable candidate availability receipts; never customer counts or population prevalence. */
import * as z from 'zod';
import { audienceSetFilterSchema } from './audience-set.js';
export const audienceAvailabilitySchema = z.strictObject({
    marketCountry: z.enum(['AU', 'US']),
    populationId: z.string().min(1),
    publicationKey: z.string().min(1),
    inputKey: z.string().min(1),
    shop: z.string().min(1),
    matchingCount: z.number().int().nonnegative(),
    expiresAt: z.number().int().positive(),
    signature: z.string().min(1),
});
export const audienceCountRequestSchema = z.strictObject({
    marketCountry: z.enum(['AU', 'US']),
    filters: audienceSetFilterSchema,
    previous: audienceAvailabilitySchema.nullable().optional(),
    fresh: z.boolean().optional(),
});
export const audienceReadinessSchema = z.strictObject({
    matchingCount: z.number().int().nonnegative(),
    requiredCount: z.number().int().positive(),
    sufficient: z.boolean(),
    message: z.string(),
});
export function describeAudienceCount(matchingCount, requiredCount) {
    const summary = `${matchingCount} candidates match your filters. This test requires ${requiredCount}.`;
    return matchingCount >= requiredCount ? summary : `${summary} Broaden or reset your filters to continue.`;
}
export function projectAudienceReadiness(availability, requiredCount) {
    return {
        matchingCount: availability.matchingCount,
        requiredCount,
        sufficient: availability.matchingCount >= requiredCount,
        message: describeAudienceCount(availability.matchingCount, requiredCount),
    };
}
/** Same normalization and input identity at the count producer and both consumers. */
export function normalizeAudienceCountFilters(input) {
    const { age_range, gender, ...rest } = input;
    const ageRange = Array.isArray(age_range)
        ? age_range
        : age_range && [age_range.min, age_range.max];
    return { ...rest, ...(ageRange ? { age_range: ageRange } : {}), ...(gender && gender !== 'All' ? { gender } : {}) };
}
export async function audienceCountInputKey(marketCountry, filters) {
    return sha256Fingerprint({ marketCountry, filters: normalizeAudienceCountFilters(filters) });
}
//# sourceMappingURL=shopify-audience-availability.js.map